exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alocationPopUp[data-v-2e37f606] {\n  max-width: 33.33333%;\n}\nth[data-v-2e37f606] {\n  font-size: 13px;\n  font-family: Roboto;\n}\ntd[data-v-2e37f606] {\n  font-size: 12px;\n  font-family: Roboto;\n}\nlabel[data-v-2e37f606] {\n  font-weight: 800;\n  color: black;\n}\n.mdltitle[data-v-2e37f606] {\n  font-size: 18px;\n}\n.custom-tabs-bg[data-v-2e37f606] {\n  background-color: #bbb6b6dc;\n  /* Replace with your desired background color */\n}\n.table-container[data-v-2e37f606] {\n  padding: 10px;\n  /* Adjust the padding as needed */\n}\n.scrollable-table[data-v-2e37f606] {\n  max-height: 250px;\n  /* Adjust the max height as needed */\n  overflow-y: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e37f606","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/wipInventory/wipInventory.component.scss
// module id = 2159
// module chunks = 0